import type { MessagingChannelsCopy } from './types';

export const JA: MessagingChannelsCopy = {
  title: 'メッセージ',
  description:
    'いつも使っているチャットアプリから IMAI と話せます。一度接続すれば、そのアプリから IMAI にメッセージを送れます。',
  privacy:
    '接続したアカウントからのメッセージは、このワークスペースであなたとして実行され、あなたのクレジットを使います。',
  loading: 'メッセージチャネルを読み込んでいます',
  unavailable: 'まだ利用できません',
  unavailableNote: '{channel} はまだ IMAI 用に設定されていません。',
  connectedBadge: '接続済み',
  cancel: 'キャンセル',

  addNumber: '番号を追加',
  countryLabel: '国番号',
  countrySearch: '国名または国番号を検索…',
  countryEmpty: '国が見つかりません。',
  numberLabel: '電話番号',
  continueActivation: '続ける',
  editNumber: '番号を変更',
  activateQr: 'スキャンして送信を押してください',
  activateHint: '{channel}を開いて送信を押してください。',
  activationBack: '戻る',
  activateButton: '{channel}を開く',
  activateWaiting:
    'メッセージを待っています。あと {time} で期限切れになります。',
  startAgain: '最初からやり直す',
  remove: '削除',
  removeAria: '電話番号 {number} を削除',
  removeTitle: '{number} を削除しますか？',
  removeDescription:
    'IMAI は iMessage と WhatsApp でこの番号に返信しなくなります。いつでも再度追加できます。',
  removeError: '番号を削除できませんでした。もう一度お試しください。',

  errorInvalidNumber: '市外局番を含む有効な電話番号を入力してください。',
  errorNumberTaken: 'この番号はすでに別の IMAI アカウントで使われています。',
  errorRateLimited:
    '試行回数が多すぎます。しばらく待ってから再度お試しください。',
  errorChannelUnavailable:
    'この方法は現在利用できません。もう一方を選んでください。',
  errorSendFailed: '確認を開始できませんでした。もう一度お試しください。',
  errorActivationExpired:
    '有効化の期限が切れました。最初からやり直してください。',

  noteSlack: 'Slack ワークスペースから IMAI にメッセージを送れます。',
  noteTeams: 'Microsoft Teams から IMAI にメッセージを送れます。',
  noteTelegram: 'Telegram で IMAI ボットとチャットできます。',
  connect: '接続',
  connectAria: '{channel} を接続',
  connectError:
    '{channel} の接続を開始できませんでした。もう一度お試しください。',
  connectedOn: '{date} に接続',
  accountFallback: 'あなたの {channel} アカウント',
  installSlack: 'IMAI をワークスペースに追加',
  installTeams: 'IMAI を Teams に追加',
  openTelegram: 'Telegram で開く',
  disconnect: '接続を解除',
  disconnectAria: '{channel} から {account} の接続を解除',
  disconnectError:
    '{channel} の接続を解除できませんでした。もう一度お試しください。',
  disconnectTitle: '{channel} の接続を解除しますか？',
  disconnectDescription:
    '{account} からのメッセージは IMAI に届かなくなります。いつでも再接続できます。',

  toastConnected: '{channel} を接続しました',
  toastConnectedGeneric: 'アカウントを接続しました',
  toastErrorExpired:
    'サインインに時間がかかりすぎました。もう一度接続してください。',
  toastErrorInvalidState:
    'このサインインリンクは無効になりました。もう一度お試しください。',
  toastErrorAccountTaken:
    'このアカウントはすでに別の IMAI ユーザーに接続されています。',
  toastErrorNotMember: 'このワークスペースのメンバーではなくなりました。',
  toastErrorProvider:
    'サインインが完了しませんでした。もう一度接続してください。',
  toastErrorGeneric:
    'アカウントを接続できませんでした。もう一度お試しください。',
};
